export const appTitle = "Levana Perps"
export const appDescription =
  "Get up to 30x leverage with minimal risk. Perpetual swaps built on Cosmos."
export const appUrl = "https://trade.levana.finance"
